import styled from "styled-components";

export const ButtonsFilterTablesDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: sticky;
  bottom: 10px;
  background-color: #fff;
  border-radius: 15px;

  /* TELA RESPONSIVA COMPUTADORES */
  @media only screen and (min-width: 481px) {
    margin: 2% 80px;
    height: 80px;

    /* .checkbox-buttons-container::-webkit-scrollbar {
      width: 0 !important;
    } */
    .checkbox-buttons-container {
      /* margin-bottom: -3%; */
      overflow: auto;
      white-space: nowrap;
    }
    .checkbox-buttons-container input {
      position: absolute;
      left: -100vw;
    }
    .checkbox-buttons-container label {
      width: 60px;
      padding: 7px;
      font-size: 15px;
      text-align: center;
      border: 2px solid #79c251;
      border-radius: 5px;
      color: #79c251;
      display: inline-block;
      background-color: #fff;
    }
    .checkbox-buttons-container .fer {
      width: 67px;
    }
    .checkbox-buttons-container .retorno {
      width: 69px;
    }
    .checkbox-buttons-container label:not(:last-child) {
      margin-right: 10px;
    }
    .checkbox-buttons-container label:hover {
      cursor: pointer;
      opacity: 0.7;
    }
    .checkbox-buttons-container input:checked + label {
      background-color: #79c251;
      color: #fff;
    }
  }

  /* TELA RESPONSIVA CELULARES */
  @media screen and (max-width: 480px) {
    height: 60px;
    margin: 3% 4%;
    .checkbox-buttons-container {
      margin-bottom: -4%;
      overflow: auto;
      white-space: nowrap;
      scrollbar-width: none;
    }
    .checkbox-buttons-container::-webkit-scrollbar {
      width: 0 !important;
    }
    .checkbox-buttons-container input {
      position: absolute;
      left: -100vw;
    }
    .checkbox-buttons-container label {
      width: 50px;
      padding: 7px;
      font-size: 14px;
      text-align: center;
      border: 2px solid #79c251;
      border-radius: 5px;
      color: #79c251;
      display: inline-block;
      background-color: #fff;
    }
    .checkbox-buttons-container .fer {
      width: 64px;
    }
    .checkbox-buttons-container .retorno {
      width: 69px;
    }
    .checkbox-buttons-container label:not(:last-child) {
      margin-right: 5px;
    }
    .checkbox-buttons-container input:checked + label {
      background-color: #79c251;
      color: #fff;
    }
  }
`;
